


























































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Plan } from "@foxone/api/src/models/hfox";
import hfoxUtils from "hfox/utils";
import { USDT_ASSET } from "hfox/constants";

@Component
class PlanInfo extends Vue {
  @Prop() plan!: Plan;

  get meta() {
    const toFiat = v =>
      this.$common.utils.currency.fiat(this, {
        from: USDT_ASSET.symbol,
        value: v
      });
    const toPrecision = this.$common.utils.number.toPrecision;
    const symbol = USDT_ASSET.symbol;
    const utils = this.$common.utils;
    const status = this.plan.status;
    const frequency = this.plan.period.frequency;
    const periodMeta = hfoxUtils.plan.getPeriodMeta(frequency);
    const statusMeta = hfoxUtils.plan.getStatusMeta(status);
    const state = status === "ACTIVE" ? periodMeta : statusMeta;
    const price = this.plan.etf.price;
    const pricePrecision = this.plan.etf.price_precision;
    const amount = this.plan.total_amount;
    const totalFunds = this.plan.total_funds;
    const total = (+price * +amount).toFixed(2);
    const change = (+total - +totalFunds).toFixed(2);
    const profit = (+total && +change / +totalFunds).toFixed(4) || 0;

    const totalFundsFiat = toFiat(totalFunds);
    const totalFiat = toFiat(total);
    const changeFiat = toFiat(change);
    const avgPrice =
      +amount === 0 ? "-" : toPrecision(+totalFunds / +amount, pricePrecision);
    const etfName = this.plan.etf_name;
    const name = this.plan.name;
    const displayName = name || etfName;

    return {
      symbol,
      avgPrice,
      total,
      amount,
      etfName,
      totalFundsFiat,
      totalFiat,
      changeFiat,
      funds: this.plan.funds,
      logo: this.plan.etf.logo,
      name: displayName,
      stateText: this.$t(state.text),
      stateColor: state.color,
      change: utils.number.addSymbol(change),
      changeColor: utils.helper.getColor(this.$store, change),
      profit: utils.number.toPercent(+profit, true),
      nextInvestTime: utils.date.formatDate(
        this.plan.next_schedule_at * 1000,
        "YYYY/MM/DD"
      ),
      description: this.plan.etf.description,
      currentPrice: utils.number.toPrecision(price, pricePrecision),
      times: this.plan.paid_schedules || 0
    };
  }
}
export default PlanInfo;
